const serverConfig = require('../../../infrastructure/serverConfig')

module.exports = ['$scope', '$timeout', '$rootScope', '$translate', 'contactListService', 'contactListMixin', '$stateParams',
  '$state', '$utils', '$ionicScrollDelegate', 'contactService', '$q', 'User', 'LocalStorage', '$sce', '$location', '$phoneModal',
  function ($scope, $timeout, $rootScope, $translate, contactListService, ContactListMixin, $stateParams,
    $state, $utils, $ionicScrollDelegate, contactService, $q, User, LocalStorage, $sce, $location, $phoneModal) {
    /* -----------------------------利用单页应用的路由思想实现在该模态框页面显示不同的联系人数据---------------------------------- */
    // 路由历史记录栈
    const routeHistory = []
    // 路由配置
    const route = {
      'frame.contactList': {
        controller: initOab
      },
      'frame.personalContact': {
        controller: getAllPabGroups
      },
      'frame.personalContactList': {
        controller: getPabGroupContacts
      }
    }

    const cancelLocationChangeListener = $rootScope.$on('$locationChangeStart', function (event, toUrl, fromUrl) {
      const toUrlQuery = $phoneModal.getModalQuery(toUrl)
      const fromUrlQuery = $phoneModal.getModalQuery(fromUrl)

      const toDepth = toUrlQuery.modalParams.depth || -1
      const fromDepth = fromUrlQuery.modalParams.depth || -1

      if (fromDepth < toDepth) { // 前进
        routeHistory.push(toUrlQuery.modalParams)
        route[currentRoute().type].controller()
      }

      if (fromDepth > toDepth) { // 后退
        if (toDepth === -1) {
          $scope.selectFilesModal.remove()
        } else {
          routeHistory.pop()
          currentRoute() && route[currentRoute().type].controller()
        }
      }
    })
    $scope.$on('$destroy', cancelLocationChangeListener)

    // 路由跳转
    const modalID = String($scope.$parent.$parent.$id) || '0' // 模态框的父级
    function goRoute(type, params) {
      const curQuery = $phoneModal.getModalQuery($location.absUrl())
      const depth = (curQuery.modalParams.depth || 0) + 1

      $phoneModal.setModalQuery({
        modalID: modalID,
        modalParams: { type: type, params: params, depth: depth }
      }, curQuery)
    }
    // 路由返回
    function backRoute() {
      history.back()
    }
    // 当前路由参数
    function currentRouteParams() {
      return routeHistory[routeHistory.length - 1].params || {}
    }
    // 当前路由
    function currentRoute() {
      return routeHistory[routeHistory.length - 1]
    }
    /* --------------------------------------------------------------------------------------------------------------------- */

    // 初始化
    goRoute('frame.contactList', { dn: '' })

    let composeContactIds = [] // 勾选的联系人id列表,用于定位ID对应的具体联系人对象在composeContact中的索引，主要用于取消勾选操作
    $scope.composeContact = [] // 勾选的联系人
    $scope.personalEntrance = [{ type: 'pab', id: 'pab' }] // 用于渲染个人通讯录入口
    $scope.selectedPabGroupIds = [] // 用于记录选中的个人通讯录分组id
    $scope.search = {}
    // 根据配置调整选择通讯录列表内用户和部门的显示顺序
    $scope.selectContactDisplayOrder = serverConfig.getItem('OabListOuAndUserDisplay') || ''

    // 功能配置读取
    $scope.enableOrganizationSelectEntrance = $rootScope.settings.featureControl.addressBook.enableOrganizationSelectEntrance
    $scope.enablePersonalSelectEntrance = $rootScope.settings.featureControl.addressBook.enablePersonalSelectEntrance
    $scope.enableStarSelectEntrance = $rootScope.settings.featureControl.addressBook.enableStarSelectEntrance
    $scope.enableStarDepartmentSelectEntrance = $rootScope.settings.featureControl.addressBook.enableStarDepartmentSelectEntrance
    $scope.enableStarContactSelectEntrance = $rootScope.settings.featureControl.addressBook.enableStarContactSelectEntrance
    $scope.enableMyDepartmentSelectEntrance = $rootScope.settings.featureControl.addressBook.enableMyDepartmentSelectEntrance

    // 初始化根目录
    function initRoot() {
      $scope.currentLocation = 'root'
      $scope.orgId = ''
      getStarDeptContact()
      getMyDepartmentObject()
      getOabDepartments()
    }
    // 组织通讯录初始化
    function initOab() {
      if (currentRouteParams().dn === '') {
        initRoot()
      } else {
        $scope.currentLocation = 'oab'
        getOabDepartments()
      }
    }
    // 获取组织通讯录部门列表
    function getOabDepartments() {
      $scope.isLoading = true
      contactService.listOabDepartments(currentRouteParams().dn).then(function (data) {
        $scope.departmentList = $scope.departmentList = data.var.ou ? data.var.ou : (currentRouteParams().dn === '' ? data.var : [])
        loadCheckedStatus($scope.departmentList)
        $scope.isRoot = true

        return currentRouteParams().dn !== '' ? getOabContacts() : $q.resolve()
      }).finally(function () {
        $scope.isLoading = false
        $ionicScrollDelegate.resize()
        $utils.$uiHelper.scrollToTop('contactScroll')
      })
    }
    // 获取组织通讯录联系人列表
    function getOabContacts() {
      $scope.start = 0
      $scope.limit = 50
      return contactService.listEx(currentRouteParams().dn, $scope.start, $scope.limit).then(function (data) {
        data.ou = data.ou || []
        $scope.contactList = data.var
        loadCheckedStatus($scope.contactList)
        $scope.hasMoreListData = $scope.contactList.length < data.total
        $scope.start = $scope.start + $scope.limit
      })
    }
    // 更多部门联系人
    $scope.getMoreContacts = function () {
      contactService.listEx(currentRouteParams().dn, $scope.start, $scope.limit).then(function (data) {
        $scope.contactList = $scope.contactList.concat(data.var)
        loadCheckedStatus($scope.contactList)
        $scope.hasMoreListData = $scope.contactList.length < data.total
        $scope.start = $scope.start + $scope.limit
      }, function () {
      }).finally(function () {
        $ionicScrollDelegate.resize()
      })
    }
    // 显示个人通讯录分组
    $scope.showGroups = function () {
      goRoute('frame.personalContact', {})
    }
    // 获取所有的个人通讯录分组
    function getAllPabGroups() {
      $scope.currentLocation = 'pabGroup'
      $scope.isLoading = true
      contactService.getPersonalGroups().then(function (data) {
        $scope.personalGroupArr = data
        loadCheckedStatus($scope.personalGroupArr)
      }, function (data) {
        $scope.personalGroupArr = data
      }).finally(function () {
        $scope.isLoading = false
        $ionicScrollDelegate.resize()
        $utils.$uiHelper.scrollToTop('contactScroll')
      })
    }
    // 显示个人通讯录分组成员
    $scope.showGroupMembers = function (groupid) {
      goRoute('frame.personalContactList', { groupid: groupid })
    }
    // 获取指定个人通讯录下的联系人列表
    function getAllContacts() {
      $scope.isLoading = true
      $scope.contactsArrUnderGroup = []
      const groupid = currentRouteParams().groupid
      contactService.getGroupPabContacts(groupid, false).then(function (data) {
        $scope.contactsArrUnderGroup = data
        loadCheckedStatus($scope.contactsArrUnderGroup)
        $scope.total = data.length
      }, function () {
      }).finally(
        function () {
          $scope.isLoading = false
          $ionicScrollDelegate.resize()
          $utils.$uiHelper.scrollToTop('contactScroll')
        }
      )
    }
    // 获取个人通讯录分组联系人列表
    function getPabGroupContacts() {
      $scope.currentLocation = 'pabContact'
      getAllContacts(currentRouteParams.groupid)
    }
    // 进入指定部门
    $scope.goContactList = function (orgId, ouId) {
      if (!orgId) {
        goRoute('frame.contactList', { dn: `${ouId}` })
        $scope.orgId = ouId
      } else {
        goRoute('frame.contactList', { dn: `${orgId}/${ouId}` })
        $scope.orgId = orgId
      }
    }
    // 返回
    $scope.goBack = function () {
      backRoute()
    }
    // 退出选择联系人页
    $scope.cancel = function () {
      history.go(-routeHistory.length)
      $scope.selectFilesModal.remove()
    }
    // 加载选中状态
    function loadCheckedStatus(list) {
      if (list) {
        list.forEach(function (item) { // 勾选组织通讯录部门或联系人或个人通讯录联系人
          if (item.type === 'oabDepartment' || item.type === 'oabContact') {
            item.isChecked = composeContactIds.indexOf(item.email) !== -1
          }
          if (item.type === 'pabContact') {
            item.isChecked = composeContactIds.indexOf('pab_' + item.id) !== -1
          }
          if (item.type === 'pabGroup') {
            item.isChecked = $scope.selectedPabGroupIds.indexOf(item.id) !== -1 // 勾选了个人通讯录分组
          }
        })
      }
    }
    // 选中
    $scope.toggleSelect = function (contact, $event) {
      if (contact.type === 'pab') {
        toggleAllPersonalContact(contact)
      } else if (contact.type === 'pabGroup') {
        togglePersonalGroup(contact)
      } else {
        toggleItemWithEmail(contact)
      }
      $event && $event.stopPropagation()
    }
    // 选中组织通讯录组织，联系人以及个人通讯录联系人，这些个体具有email
    function toggleItemWithEmail(contact) {
      contact.isChecked = !contact.isChecked
      const id = contact.type === 'pabContact' ? 'pab_' + contact['id'] : contact['email']
      if (contact.isChecked) {
        composeContactIds.push(id)
        $scope.composeContact.push(contact)
      } else {
        const index = composeContactIds.indexOf(id)
        composeContactIds.splice(index, 1)
        $scope.composeContact.splice(index, 1)
      }
      $scope.contactNum = $scope.composeContact.length
    }
    // 选中个人通讯录
    function toggleAllPersonalContact(ou) {
      ou.isChecked = !ou.isChecked
      if (ou.isChecked) {
        contactService.getAllPabContacts().then(function (data) {
          data.forEach(function (item) {
            if (composeContactIds.indexOf('pab_' + item.id) === -1) {
              composeContactIds.push('pab_' + item.id)
              $scope.composeContact.push(item)
            }
          })
          $scope.contactNum = $scope.composeContact.length
        }, function () {
        })
      } else {
        const tempContacts = []
        const tempIds = []
        $scope.composeContact.forEach(function (item, index) {
          if (item.type !== 'pabContact') {
            tempContacts.push(item)
          }
        })
        composeContactIds.forEach(function (item) {
          if (item.indexOf('pab_') === -1) {
            tempIds.push(item)
          }
        })
        $scope.composeContact = tempContacts
        composeContactIds = tempIds
        $scope.contactNum = $scope.composeContact.length
      }
    }
    // 选中个人通讯录分组
    function togglePersonalGroup(group) {
      group.isChecked = !group.isChecked
      if (group.isChecked) {
        $scope.selectedPabGroupIds.push(group.id)
        const groupid = group.id
        contactService.getGroupPabContacts(groupid, false).then(function (data) {
          data.forEach(function (item) {
            if (composeContactIds.indexOf('pab_' + item.id) === -1) {
              composeContactIds.push('pab_' + item.id)
              $scope.composeContact.push(item)
            }
          })
          $scope.contactNum = $scope.composeContact.length
        }, function () {
        })
      } else {
        const index = $scope.selectedPabGroupIds.indexOf(group.id)
        $scope.selectedPabGroupIds.splice(index, 1)
        const tempContacts = []
        const tempIds = []
        $scope.composeContact.forEach(function (item, index) {
          if (item.type !== 'pabContact' && group.id === 'ALLPERSONALCONTACTS') {
            tempContacts.push(item)
            tempIds.push(item.email)
          }
          if (group.id === 'OTHER' && item.type === 'pabContact' && item.groups.length !== 0) {
            tempContacts.push(item)
            tempIds.push('pab_' + item.id)
          }
          if (group.id !== 'OTHER' && group.id !== 'ALLPERSONALCONTACTS' && item.type === 'pabContact' && item.groups.indexOf(group.id) === -1) {
            tempContacts.push(item)
            tempIds.push('pab_' + item.id)
          }
        })
        $scope.composeContact = tempContacts
        composeContactIds = tempIds
        $scope.contactNum = $scope.composeContact.length
      }
    }
    // 确认选择
    $scope.deliverContact = function () {
      history.go(-routeHistory.length)
      $scope.$emit('commitSelectedUser', $scope.composeContact)
    }
    // 搜索联系人
    $scope.searchContact = function () {
      $scope.isSearching = true
      const currentSearchLocation = currentRoute().type
      switch (currentSearchLocation) {
        case 'frame.contactList':
          searchOabContacts()
          break
        case 'frame.personalContact':
          searchPabContacts()
          break
        case 'frame.personalContactList':
          searchPabContacts()
          break
      }
    }
    // 搜索组织通讯录
    function searchOabContacts() {
      $scope.isLoading = true
      $scope.search.notFoundKeyword = $scope.search.keyword
      contactService.searchOabContacts($scope.search.keyword, currentRouteParams().dn).then(function (oabResult) {
        if (currentRouteParams().dn === '') {
          contactService.searchPabContacts($scope.search.keyword).then(function (pabResult) {
            $scope.searchShowList = wrapContacts(oabResult.concat(pabResult))
            loadCheckedStatus($scope.searchShowList)
            $scope.noResultFound = !$scope.searchShowList.length
            $scope.isLoading = false
          }, function () {
          })
        } else {
          $scope.searchShowList = oabResult
          loadCheckedStatus($scope.searchShowList)
          $scope.noResultFound = !$scope.searchShowList.length
          $scope.isLoading = false
        }
      }, function () {
      })
    }
    // 搜索个人通讯录
    function searchPabContacts() {
      $scope.search.notFoundKeyword = $scope.search.keyword
      contactService.searchPabContacts($scope.search.keyword).then(function(pabResult) {
        $scope.searchShowList = pabResult
        loadCheckedStatus($scope.searchShowList)
        $scope.noResultFound = !$scope.searchShowList.length
      }, function() {})
    }
    // 对传入的联系人数组做一些包装处理（高亮操作等）
    function wrapContacts(contacts) {
      contacts.forEach(function (item) {
        if (item.type === 'oabContact') {
          item.highLightEmail = highLightKeyword($scope.search.keyword, item['email'])
          item.highLightName = highLightKeyword($scope.search.keyword, item['true_name'])
        }
        if (item.type === 'pabContact') {
          item.highLightName = highLightKeyword($scope.search.keyword, item['FN'])
          item.highLightEmail = highLightKeyword($scope.search.keyword, item['EMAIL;PREF'])
        }
      })
      return contacts
    }

    // 高亮字段中的关键字
    function highLightKeyword(keyword, contactName) {
      if (contactName) {
        keyword = keyword.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&')
        const pattern = new RegExp(keyword, 'i')
        const tempName = contactName.replace(pattern, "<span class='highlight'>$&</span>")
        return $sce.trustAsHtml(tempName)
      }
    }
    // 处理搜索关键字的变化
    $scope.searchKeywordChange = function () {
      if (!$scope.search.keyword) {
        $scope.noResultFound = false
        $scope.isSearching = false
        $scope.searchShowList = null
      }
    }
    // 获取星标部门和星标联系人
    function getStarDeptContact() {
      contactService.getStarDeptContact('department').then(function (data) {
        data.forEach(function(item) {
          item.type = 'oabDepartment'
        })
        $scope.starDepartments = data
        loadCheckedStatus($scope.starDepartments)
      }, function (data) {
        $scope.starDepartments = data
      })
      contactService.getStarDeptContact('contact').then(function (data) {
        data.forEach(function(item) {
          if (item.type === 'pab') {
            item.type = 'pabContact'
          } else {
            item.type = 'oabContact'
          }
        })
        $scope.starContacts = data
        loadCheckedStatus($scope.starContacts)
      }, function (data) {
        $scope.starContacts = data
      })
    }
    // 获取我的部门的组织通讯录路径
    function getMyDepartmentObject() {
      $scope.myDepartmentObject = {}
      contactService.getOabContact(User.getConfig().email, false).then(function (data) {
        if (data['@ou'] && data['email']) {
          $scope.myDepartmentObject.path = data['@ou']
          contactService.getOabStructureBydn({ dn: data['@ou'], attrIds: 'email' }).then(function (data) {
            $scope.myDepartmentObject.email = data.email
            $scope.myDepartmentObject.name = data.name
            $scope.myDepartmentObject.type = 'oabDepartment'
            const temp = [$scope.myDepartmentObject]
            loadCheckedStatus(temp)
          })
        }
      }, function () {
      })
    }
    // 进入我的部门
    $scope.intoMyDepartment = function () {
      const dn = $scope.myDepartmentObject.path
      goRoute('frame.contactList', { dn: dn })
      $scope.orgId = dn.split('/')[0]
    }
    // 点击星标部门进入
    $scope.goStarDeptList = function (path, id) {
      const orgId = path.split('/')[1]
      $scope.goContactList(orgId, id)
    }
    $timeout(_ => {
      $scope.$broadcast('ADDRESSBOOK.CONTENT_LOADED')
    }, 100)
  }]



// WEBPACK FOOTER //
// ./src/js/addressbook/organizational/contact/selectContactListCtrl.js